import React from 'react';
export function Footer() {
  return <footer className="py-12 border-t border-charcoal-200" data-id="element-100">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-101">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-102">
          <div className="text-sm text-charcoal-400" data-id="element-103">
            © 2025 caltalk. all rights reserved.
          </div>
          <div className="flex gap-8 text-sm" data-id="element-104">
            <a href="/privacy" className="text-charcoal-400 hover:text-coral-600 transition-colors" data-id="element-105">
              privacy
            </a>
            <a href="/terms" className="text-charcoal-400 hover:text-coral-600 transition-colors" data-id="element-106">
              terms
            </a>
            <a href="mailto:info@caltalk.ai" className="text-charcoal-400 hover:text-coral-600 transition-colors" data-id="element-107">
              contact
            </a>
          </div>
        </div>
      </div>
    </footer>;
}